import { useCallback, useEffect, useState } from 'react'

import { isOnboardingCallCtaBooked, ONBOARDING_CALL_CTA_BOOKED_EVENT } from './onboarding-call-cta-booking-storage'

/** True when this user+company completed booking via in-app Calendly embed (localStorage). */
export function useOnboardingCallCtaBooked(userId?: string, companyId?: string): boolean {
  const [booked, setBooked] = useState(() => isOnboardingCallCtaBooked(userId, companyId))

  useEffect(() => {
    setBooked(isOnboardingCallCtaBooked(userId, companyId))
  }, [userId, companyId])

  const refresh = useCallback(() => {
    setBooked(isOnboardingCallCtaBooked(userId, companyId))
  }, [userId, companyId])

  useEffect(() => {
    window.addEventListener('storage', refresh)
    window.addEventListener(ONBOARDING_CALL_CTA_BOOKED_EVENT, refresh as EventListener)
    return () => {
      window.removeEventListener('storage', refresh)
      window.removeEventListener(ONBOARDING_CALL_CTA_BOOKED_EVENT, refresh as EventListener)
    }
  }, [refresh])

  return booked
}
